/**
 * External dependencies
 */
import React from 'react';
import { connect } from 'react-redux';
import page from 'page';

/**
 * Internal dependencies
 */
import Main from 'components/main';
import DocumentHead from 'data/document-head';
import Topbar from 'modules/me/topbar';
import SelectSupportPlan from 'modules/me/select-support-plan';
import { Stack, Text, Heading, Box } from '@towersystems/towersystems-design-system';
import AnnotatedSection from 'components/annotated-section';
import Notice from 'components/notice';
import { getBusinessName } from 'state/current-user/selectors';

const NewSupport = ({ businessName }) => {
    
    const onSuccessPlanSelect = () => {
        page.redirect('/dashboard/support');
    };

    return (
        <Box>
            <DocumentHead title='Billing - Tower Systems' />
            <Topbar title='Support Plan' subTitle={'Hello ' + businessName} selected='support' />
            <Box marginBottom='xxlarge'>
                <Notice
                    showDismiss={false}
                    text='Action Required!'
                    subText='Please select a support plan to continue.'
                />
            </Box>
            <Main padding='xxlarge'>
                <Stack space='xxlarge'>
                    <Box>
                        <Heading level='3'>Select a support plan</Heading>
                        <Text>
                            *Prices are excluding any applicable discounts. Please click on a support plan below to view
                            the estimated plan price.
                        </Text>
                    </Box>
                    <Box>
                        <SelectSupportPlan afterSuccess={onSuccessPlanSelect} />
                    </Box>
                </Stack>
            </Main>
        </Box>
    );
};

export default connect((state) => ({businessName: getBusinessName(state),}), {})(NewSupport);
